<template>
	<div>
		<ul class="uploadwechat">
			<li v-for="(item,index) in fileList" :key="index">
				<div class="uploadwechatdiv">
					<van-icon name="clear" class="del" @click="del(index)" size="20" />
					<img :src="item" />
				</div>
			</li>

			<li @click="uploadwechat">
				<div class="uploadwechatdiv">
					<van-icon name="plus" size="20" />
					<p>
						上传图片
						<br />最多6张
					</p>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
	var root = process.env.VUE_APP_API_URL;

	import {
		Uploader,
		Toast,
		Button,
		Icon
	} from "vant";

	export default {
		components: {
			[Uploader.name]: Uploader,
			[Toast.name]: Toast,
			[Button.name]: Button,
			[Icon.name]: Icon
		},

		data() {
			return {
				getUploadUrl: root + "upload/baseimg",
				getUploadIndexUrl: root + "upload/index",
				getWechatUrl: root + "wechat/index",
				fileList: [],
				pictures: []
			};
		},
		props: {
			type: String
		},
		mounted() {
			this.init();
		},

		methods: {
			init() {
				var self = this;
				$.ajax({
					url: self.getWechatUrl,
					timeout: 120000,
					dataType: "json",
					type: "get",
					data: {
						url: location.href
					},
					headers: self.getRequestHeader(),
					success: function(reponseData, status) {
						console.log(reponseData.appId);

						wx.config({
							debug: false,
							appId: reponseData.appId,
							timestamp: reponseData.timestamp,
							nonceStr: reponseData.nonceStr,
							signature: reponseData.signature,
							jsApiList: [
								"chooseImage",
								"previewImage",
								"uploadImage",
								"downloadImage"
							]
						});
					},
					error: function() {
						self.$toast("system error");
					}
				});
			},
			uploadwechat() {
				var self = this;

				wx.ready(function() {
					wx.chooseImage({
						count: 6, // 默认9
						sizeType: ["compressed"], // 可以指定是原图还是压缩图，默认二者都有
						sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
						success: function(res) {
							 for (var i = 0; i < res.localIds.length; i++) {
								 self.uploadImage(res.localIds[i])
							 }
							
							
						}
					});
				});
			},
			uploadImage(file) {
				var self = this;
				wx.uploadImage({
					url: self.getUploadIndexUrl, // 服务器接收上传文件的URL
					filePath: file, // 要上传文件资源的路径
					name: 'file', // 文件对应的key
					formData: {
						'user': 'test' // 其他要上传的参数
					},
					header: self.getRequestHeader(),
					success: function(reponseData) {
						// 上传成功后的操作
						console.log(reponseData.data);
						self.pictures.push(reponseData.url);
					},
					fail: function(uploadRes) {
						// 上传失败的操作
						console.log('upload fail:', uploadRes);
					}
				});
			},
			upload(fileList, i) {
				var self = this;
				if (fileList.length == i) {
					self.$toast.clear();
					self.$emit("change", self.pictures);
					return;
				}
				self.$toast.loading({
					mask: true,
					duration: 0,
					message: "第" + (i + 1) + "张上传中"
				});
				var base64 = fileList[i];
				var formData = new FormData();
				formData.append("file", base64);
				formData.append("name", "");
				$.ajax({
					url: self.getUploadUrl,
					async: true,
					timeout: 120000,
					dataType: "json",
					type: "post",
					data: formData,
					processData: false, // 不处理数据
					contentType: false, // 不设置内容类型
					headers: self.getRequestHeader(),
					success: function(reponseData, status) {
						self.pictures.push(reponseData.url);
						i++;
						self.upload(fileList, i);
					},
					error: function() {
						self.$toast("system error");
					}
				});
			},
			del(index) {
				this.fileList.splice(index, 1);
				this.pictures.splice(index, 1);
			}
		}
	};
</script>

<style scoped>
	.uploadwechat {
		display: flex;
		flex-flow: wrap;
		justify-content: space-between;
	}

	.uploadwechat li {
		width: 23%;

		margin-bottom: 10px;
	}

	.uploadwechat li p {
		padding: 8px 0 0 0;
		font-size: 12px;
	}

	.uploadwechat li .uploadwechatdiv {
		border: #eee 1px dashed;
		height: 80px;
		border-radius: 4px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #888;
		flex-direction: column;
		position: relative;
		overflow: hidden;
		background-color: #f8f8f8;
	}

	.uploadwechat li .uploadwechatdiv img {
		width: 100%;
		max-height: 78px;
	}

	.uploadwechat li .uploadwechatdiv .del {
		position: absolute;
		right: 0;
		bottom: 0;
		top: 0;
		left: 0;
		margin: auto;
		width: 24px;
		height: 24px;
	}
</style>>